import { QueryFactory } from "../../../../Common";
export const QGetEventsFromTopLeaguesBySportId = QueryFactory("GetEventsFromTopLeaguesBySportId");
//# sourceMappingURL=QGetEventsFromTopLeaguesBySportId.js.map